var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningRoundFilledBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M29.625 50.625C41.0159 50.625 50.25 41.3909 50.25 30C50.25 18.6091 41.0159 9.375 29.625 9.375C18.2341 9.375 9 18.6091 9 30C9 41.3909 18.2341 50.625 29.625 50.625Z",
    fill: "#324F96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.25 39.2697C32.25 40.1431 31.728 42.375 29.2341 42.375C26.7403 42.375 26.25 40.1431 26.25 39.2697C26.25 38.4168 26.8058 36.1274 29.2341 36.1274C31.6625 36.1274 32.25 38.4168 32.25 39.2697ZM26.4973 31.0697V20.3008C26.4973 18.8231 27.7294 17.625 29.2489 17.625C30.7685 17.625 32.0006 18.8231 32.0006 20.3008V31.0718C32.0006 32.5494 30.7685 33.7475 29.2489 33.7475C27.7294 33.7455 26.4973 32.5473 26.4973 31.0697Z",
    fill: "#324F96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningRoundFilledBlue);
export default __webpack_public_path__ + "static/media/warning-round-filled-blue.d49831f2f4f8a1ba22b9f7127c481b2d.svg";
export { ForwardRef as ReactComponent };